import { render, staticRenderFns } from "./HintSidebar.vue?vue&type=template&id=bfa5726a&scoped=true"
import script from "./HintSidebar.vue?vue&type=script&lang=js"
export * from "./HintSidebar.vue?vue&type=script&lang=js"
import style0 from "./HintSidebar.vue?vue&type=style&index=0&id=bfa5726a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5726a",
  null
  
)

export default component.exports